import { render, staticRenderFns } from "./f-data-notices.vue?vue&type=template&id=146375a9&scoped=true"
import script from "./f-data-notices.vue?vue&type=script&lang=js"
export * from "./f-data-notices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146375a9",
  null
  
)

export default component.exports